var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"promote"},[_c('img',{staticClass:"promote-bg",attrs:{"src":_vm.qrcode,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }